import axiosClient from '../api/AxiosConfig';

export const StoreService = {
  GetStores: async () => (await axiosClient.get('/store/private')).data,
  DisableStore: async (id) => (await axiosClient.patch(`/store/${id}/disable`)).data,
  EnableStore: async (id) => (await axiosClient.patch(`/store/${id}/enable`)).data,
  DeleteStore: async (id) => (await axiosClient.delete(`/store/${id}/delete`)).data,
  CreateStore: async (data) => (await axiosClient.post('/store', data)).data,
  EditStore: async (data, id) => (await axiosClient.put(`/store/${id}/edit`, data)).data,
};
